import { render } from "./UpdateExtension.vue?vue&type=template&id=f9bf1db0&scoped=true"
import script from "./UpdateExtension.vue?vue&type=script&lang=js"
export * from "./UpdateExtension.vue?vue&type=script&lang=js"

import "./UpdateExtension.vue?vue&type=style&index=0&id=f9bf1db0&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9bf1db0"]])

export default __exports__